import IntroUniverse from "@/components/IntroUniverse";
import React from "react";
import {motion} from "motion/react"
import {r} from "@/utils/responsive";

interface IntroUniverseLayerProps
    extends React.HTMLAttributes<HTMLDivElement> {
}

const IntroUniverseLayer: React.FC<IntroUniverseLayerProps> = ({
                                                                   className,
                                                                   ...props
                                                               }) => {
    return (
        <motion.div initial={{
            translateX: r.vmax(-500),
            translateY: r.vmax(500),
            opacity: 0,
        }} animate={{
            translateX: 0,
            translateY: 0,
            opacity: 1,
        }} exit={{
            translateX: 0,
            translateY: '-100%',
            opacity: 0,
        }} transition={{duration: .75, ease: 'easeInOut'}} style={{
            position: 'absolute',
            inset: 0
        }}>
            <IntroUniverse/>
        </motion.div>
    );
};

export default IntroUniverseLayer;
